<template lang="pug">
ul.section-options
  li(
    v-for="rso in registration.lookupRSOs(section.id)",
    :class="{'disabled': disable_block_for_family}"
  )
    keep_hidden(:obj='rso.section_option', klass='sectionoption')
    valid_today_dates(:obj='rso.section_option', klass='sectionoption')
    // = option_fields.hidden_field :_destroy, value: registration_section_option.new? ? '1' : '0', data: { option: 'section' }

    .label-text.label_with_indentation
      strong
        WithRequired(:required="rso.section_option.required", :text="rso.section_option.name")
    .label-text.label_with_indentation(v-if="isPresent(rso.section_option.description)")
      WithRequired(:required="false", :text="rso.section_option.description", :cut_text="true")

    Choices(:rso="rso")

    .field(v-if="rso.section_option.eligibility_required && rso.choice_ids.length > 0", style="margin-left: 25px")
      validation-provider(v-slot="{ errors }" rules="required")
          .addon-eligibility(:class="{error: errors[0]}")
            span.required-text {{t('helpers.label.addon.this_field_is_required')}}
            span.required(v-if="!disable_block_for_family") *
          FloatingLabel(:config="{label: rso.section_option.eligibility_text, required: true}")
            input(v-model="rso.eligibility_requirement" :class="{error: errors[0]}" type="text" :placeholder="rso.section_option.eligibility_text",:disabled="disable_block_for_family",required)
</template>

<script>
  import helpers from 'code/base_mixins'
  import WithRequired from "../shared/_with_required";
  import keep_hidden from "../_keep_hidden"
  import valid_today_dates from "../_valid_today_dates"
  import Choices from './option/_choices'

  export default {
    mixins: [helpers],
    props: ["section", "disable_block_for_family"],
    components: {WithRequired,valid_today_dates,keep_hidden,Choices},

    computed: {
      registration() {
        return this.state.current_reg
      },
      validate() {
        return this.registration.isStillPending()
      },
      disabled() {
        return this.registration.disable_reg_block(this.state.current_org)
      },
    }
  }
</script>

<style scoped lang="scss">
  .gray {
    color: gray;
  }
</style>